export default __webpack_public_path__ + "bad03d710f2ffdff438fc8d7fafb240a.glb";